"use strict";

;

(function () {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  var trident = ua.indexOf('Trident/');
  var edge = ua.indexOf('Edge/');
  var _document = document,
      body = _document.body;

  if (msie > 0) {
    body.classList.add('ie');
  }

  if (trident > 0) {
    body.classList.add('ie');
  }

  if (edge > 0) {
    body.classList.add('ie');
  }
})();